const has = (title, re) => re.test(title.toLowerCase());
export function templateCrmCategory(template) {
    if (template.crmCategory)
        return template.crmCategory;
    switch (template.key) {
        case 'general-partnerships': return 'Partnerships';
        case 'experiential':
        case 'event-marketing': return 'Events & Experiential';
        case 'campaign-marketing': return 'Marketing';
        case 'creative': return 'Creative';
        default: return 'Misc';
    }
}
export function templateScriptSection(template) {
    if (template.scriptSection)
        return template.scriptSection;
    if (template.key === 'event-marketing')
        return 'Event Marketing';
    return templateCrmCategory(template);
}
export function scriptSectionForCategory(category, title = '') {
    if (category === 'Events & Experiential' && /\bevents? marketing\b/i.test(title))
        return 'Event Marketing';
    return category;
}
export function routeRole(rawTitle) {
    const title = String(rawTitle || '').trim();
    if (has(title, /partnership|sponsorship|commercial partnership|partner marketing|alliances?/)) {
        return { department: 'partnerships', crmCategory: 'Partnerships', script: 'general-partnerships', subject: 'Partnerships Creative Support', confident: true, reason: 'Partnership / sponsorship ownership detected in the role title.' };
    }
    if (has(title, /\bevent marketing\b|\bevents marketing\b/)) {
        return { department: 'marketing', crmCategory: 'Events & Experiential', script: 'event-marketing', subject: 'Marketing Creative Support', confident: true, reason: 'Event marketing ownership detected; kept within Events & Experiential while using the existing Event Marketing script.' };
    }
    if (has(title, /experiential|brand experience|fan experience|fan engagement|supporter experience|supporter engagement|guest experience|live experience|audience experience|visitor experience|hospitality|activation|event experience|live event|\bevents?\b|event management|event production|event operations|event delivery/)) {
        return { department: 'experiential', crmCategory: 'Events & Experiential', script: 'experiential', subject: 'Experiential Creative Support', confident: true, reason: 'Event / experiential / activation ownership detected in the role title.' };
    }
    if (has(title, /\b(head|director|manager|lead|vp|vice president|chief)\s+(?:of\s+)?brand\b|\bbrand\s+(?:director|manager|lead|strategy|identity|creative)\b/)) {
        return { department: 'creative', crmCategory: 'Creative', script: 'creative', subject: 'Creative Support', confident: true, reason: 'Brand ownership detected; brand roles are treated as Creative unless a stronger Partnerships / Experiential signal matched first.' };
    }
    if (has(title, /creative|design|art director|designer|creative producer|content producer|studio/)) {
        return { department: 'creative', crmCategory: 'Creative', script: 'creative', subject: 'Creative Support', confident: true, reason: 'Creative / design ownership detected in the role title.' };
    }
    if (has(title, /marketing|campaign|content marketing|social|communications|\bcomms\b|\bpr\b|product marketing|growth marketing|digital marketing|performance marketing|paid media|media planning|customer acquisition|lifecycle|crm marketing/)) {
        return { department: 'marketing', crmCategory: 'Marketing', script: 'campaign-marketing', subject: 'Marketing Creative Support', confident: true, reason: 'Marketing ownership detected in the role title.' };
    }
    if (has(title, /commercial|business development|\bbd\b|sales|revenue/)) {
        return { department: 'commercial', crmCategory: 'Misc', script: 'general-partnerships', subject: 'Creative Support', confident: true, reason: 'Commercial / business-development role detected.' };
    }
    return { department: 'other', crmCategory: 'Misc', script: 'campaign-marketing', subject: 'Creative Support', confident: false, reason: 'No strong functional signal in the role title; manual review recommended.' };
}
export function routeRoleWithOpportunity(rawTitle, opportunity) {
    const route = routeRole(rawTitle);
    if (route.confident)
        return route;
    const tags = (opportunity?.serviceTags ?? []).join(' ').toLowerCase();
    if (/experiential|hospitality|fan experience|brand experience|activation|3d/.test(tags)) {
        return { department: 'experiential', crmCategory: 'Events & Experiential', script: 'experiential', subject: 'Experiential Creative Support', confident: false, reason: 'Role title was ambiguous; experiential opportunity context used as fallback.' };
    }
    if (opportunity?.type === 'future-event') {
        return { department: 'marketing', crmCategory: 'Events & Experiential', script: 'event-marketing', subject: 'Marketing Creative Support', confident: false, reason: 'Role title was ambiguous; future-event context used as fallback to Event Marketing within Events & Experiential.' };
    }
    if (opportunity?.type === 'new-partnership') {
        return { department: 'partnerships', crmCategory: 'Partnerships', script: 'general-partnerships', subject: 'Partnerships Creative Support', confident: false, reason: 'Role title was ambiguous; partnership context used as fallback.' };
    }
    return route;
}
export function scriptForCrmCategory(category, title = '') {
    switch (category) {
        case 'Partnerships':
            return { department: 'partnerships', crmCategory: category, script: 'general-partnerships', subject: 'Partnerships Creative Support', confident: true, reason: 'CRM category manually set to Partnerships.' };
        case 'Events & Experiential':
            if (/\bevent marketing\b/i.test(title)) {
                return { department: 'marketing', crmCategory: category, script: 'event-marketing', subject: 'Marketing Creative Support', confident: true, reason: 'Event Marketing role retained within Events & Experiential category.' };
            }
            return { department: 'experiential', crmCategory: category, script: 'experiential', subject: 'Experiential Creative Support', confident: true, reason: 'CRM category manually set to Events & Experiential.' };
        case 'Marketing':
            return { department: 'marketing', crmCategory: category, script: 'campaign-marketing', subject: 'Marketing Creative Support', confident: true, reason: 'CRM category manually set to Marketing.' };
        case 'Creative':
            return { department: 'creative', crmCategory: category, script: 'creative', subject: 'Creative Support', confident: true, reason: 'CRM category manually set to Creative.' };
        default:
            return routeRole(title);
    }
}
